import store from 'module/store';
import getQuoteForm from "module/quoteForm/get";

export default  getQuoteForm(store);
